import React from "react";

export type Props = {
  text: string;
  isLoading?: boolean;
  disabled?: boolean;
  isFullWidth?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};
const Button: React.FC<Props> = ({ text, isLoading = false, disabled = false, isFullWidth = true, onClick }) => {
  return (
    <button
      className={`${isLoading ? "is-loading" : ""} ${
        isFullWidth ? "is-fullwidth" : ""
      } button is-small is-radiusless has-background-light has-text-primary`}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Button;
